"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgUserGroupRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "m25.333 28 4-4m0 0-4-4m4 4h-8m-.666-19.612a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
exports.default = SvgUserGroupRight;
//# sourceMappingURL=UserGroupRight.js.map